<template>
<div class="lvChatFastBox">
<!--  标题-->
  <div class="chatFastTitle">便捷发言</div>
<!--  发言便捷条-->
  <div class="chatList clear-fix">
    <div class="chatListItem" v-for="(item, index) in arrChatFast">
      <span @click="clickChatListItem(index)">{{ item }}</span>
    </div>
  </div>

  <div class="chatListOff"></div>
</div>
</template>

<script>
export default {
  name: "lvChatFast",
  props:{
    arrChatFast:{
      type: Array,
      required: true
    },
  },
  methods:{
    clickChatListItem(index){
      console.log("click :" + index)
      this.$emit("sendFastContent", index)
    }
  }
}
</script>

<style scoped>
.chatListOff{
  width: 100%;
  height: 150px;
  /*background-color: #07c160;*/
}
.lvChatFastBox{
  width: 100%;
}
.chatFastTitle{
  text-align: center;
  /*height: 40px;*/
  /*line-height: 40;*/
  font-size: 40px;
  margin-top: 40px;
  margin-bottom: 30px;
  color: whitesmoke;
  letter-spacing: 6px;
}
.chatList{
  position: relative;

  margin: auto;
  margin-left: 45px;
  margin-right: 45px;
  color: whitesmoke;
  font-size: 40px;
  text-align: center;
  width: 95%;
  min-height: 300px;
  /*background-color: #287c8f;*/
}

.chatListItem{
  float: left;
  flex-direction: row;
  margin-right: 45px;
  margin-top: 40px;
}

.chatListItem span{
  background-color: #009bff;
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 50px;
}

</style>